const required = (
  value: string | undefined,
  name: string,
  fallback?: string,
) => {
  const resolved = value ?? fallback;
  if (!resolved) {
    throw new Error(`Missing environment variable: ${name}`);
  }
  return resolved;
};

const vercelUrl = process.env.VERCEL_URL
  ? `https://${process.env.VERCEL_URL}`
  : undefined;

export const APP_URL = required(
  process.env.NEXT_PUBLIC_APP_URL ?? process.env.NEXT_PUBLIC_SITE_URL,
  "NEXT_PUBLIC_APP_URL",
  vercelUrl ?? "http://localhost:3000",
);

export const SITE_URL = required(
  process.env.NEXT_PUBLIC_SITE_URL ?? process.env.NEXT_PUBLIC_APP_URL,
  "NEXT_PUBLIC_SITE_URL",
  vercelUrl ?? "http://localhost:3000",
);

export const HUBSPOT_MEETING_URL =
  process.env.NEXT_PUBLIC_HUBSPOT_MEETING_URL ?? "";

export const CALCOM_URL =
  process.env.NEXT_PUBLIC_CALCOM_URL ?? "demo/30min";

/** Booking link for the free-health-check results page's "walk through these
 * findings" CTA. Falls back to CALCOM_URL (the same verified-working event
 * /demo uses) rather than a dedicated discovery-call slug that may not exist
 * yet — set NEXT_PUBLIC_CALCOM_DISCOVERY_URL once a distinct event is
 * created, no code change required. */
export const CALCOM_DISCOVERY_URL =
  process.env.NEXT_PUBLIC_CALCOM_DISCOVERY_URL ?? CALCOM_URL;
